import ActionTypes from '../types'

export const setNotification = notification => ({
  type: ActionTypes.SET_NOTIFICATION,
  payload: notification
})
